import { render, staticRenderFns } from "./VatWarning.vue?vue&type=template&id=f0f8fa7e&scoped=true"
import script from "./VatWarning.vue?vue&type=script&lang=ts"
export * from "./VatWarning.vue?vue&type=script&lang=ts"
import style0 from "./VatWarning.vue?vue&type=style&index=0&id=f0f8fa7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0f8fa7e",
  null
  
)

export default component.exports